const mediaQuery = 'screen and (orientation: landscape) and (min-height: 320px) and (min-width: 568px), screen and (orientation: portrait) and (min-width: 568px)';

export default mediaQuery;
